<div class="container">
    <div class="section-title">
        <h2>Unsere Vorteile</h2>
        <div class="bar"></div>
        <p>Bei Tommys Fahrschule profitierst du von einer modernen, flexiblen und effektiven Ausbildung – individuell auf dich abgestimmt.</p>
    </div>

    <div class="row">
        <div class="col-lg-4 col-md-6">
            <div class="single-features">
                <div class="icon">
                    <i class="fa fa-sun"></i>
                </div>
                <h3>Theorie in 7 Tagen</h3>
                <p>Schnell, intensiv und effizient – absolviere deine theoretische Ausbildung innerhalb einer Woche in modernen Räumen.</p>
            </div>
        </div>

        <div class="col-lg-4 col-md-6">
            <div class="single-features">
                <div class="icon">
                    <i class="fa fa-lightbulb"></i>
                </div>
                <h3>Junges & motiviertes Team</h3>
                <p>Unsere Fahrlehrer begleiten dich mit Geduld, Know-how und guter Laune durch jede Phase deiner Ausbildung.</p>
            </div>
        </div>

        <div class="col-lg-4 col-md-6">
            <div class="single-features">
                <div class="icon">
                    <i class="fa fa-desktop"></i>
                </div>
                <h3>Online Lernen möglich</h3>
                <p>Lerne flexibel von überall – mit deinem Smartphone, Tablet oder PC. Perfekt für deinen Alltag.</p>
            </div>
        </div>

        <div class="col-lg-4 col-md-6">
            <div class="single-features">
                <div class="icon">
                    <i class="fa fa-code"></i>
                </div>
                <h3>Moderne Fahrzeuge</h3>
                <p>Unsere Flotte ist auf dem neuesten Stand – für ein angenehmes Fahrgefühl und sicheres Lernen auf der Straße.</p>
            </div>
        </div>

        <div class="col-lg-4 col-md-6">
            <div class="single-features">
                <div class="icon">
                    <i class="fa fa-eye"></i>
                </div>
                <h3>Transparente Preise</h3>
                <p>Bei uns weißt du genau, was auf dich zukommt – ohne versteckte Kosten, mit fairem Preis-Leistungs-Verhältnis.</p>
            </div>
        </div>

        <div class="col-lg-4 col-md-6">
            <div class="single-features">
                <div class="icon">
                    <i class="fa fa-camera"></i>
                </div>
                <h3>Flexible Fahrstunden</h3>
                <p>Individuelle Terminplanung ganz nach deinem Zeitplan – so passt deine Fahrausbildung perfekt in deinen Alltag.</p>
            </div>
        </div>
    </div>
</div>
